import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var state,
        commit,
        rootState,
        getters,
        rootGetters,
        dispatch,
        _ref3,
        _ref3$resetFilterWork,
        resetFilterWorkers,
        _ref3$isForce,
        isForce,
        visibleDates,
        from,
        to,
        depId,
        tableView,
        emplIds,
        params,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = _ref.state, commit = _ref.commit, rootState = _ref.rootState, getters = _ref.getters, rootGetters = _ref.rootGetters, dispatch = _ref.dispatch;
            _ref3 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref3$resetFilterWork = _ref3.resetFilterWorkers, resetFilterWorkers = _ref3$resetFilterWork === void 0 ? true : _ref3$resetFilterWork, _ref3$isForce = _ref3.isForce, isForce = _ref3$isForce === void 0 ? false : _ref3$isForce;
            commit('setIsLoading', true);
            visibleDates = rootGetters['timetable/visibleDates'];
            from = visibleDates[0];
            to = visibleDates.slice(-1)[0];
            depId = rootGetters['queryMirrored/getOneDep'];
            tableView = rootState.queryMirrored.tableView || [];

            if (!(!state.updatedData['allTable'] || isForce)) {
              _context.next = 11;
              break;
            }

            _context.next = 11;
            return dispatch('getDataForAllTables', {
              from: from,
              to: to,
              depId: depId,
              resetFilterWorkers: resetFilterWorkers
            });

          case 11:
            emplIds = getters['workerEmplIds'];
            params = {
              'dt__gte': from,
              'dt__lte': to,
              'employee_id__in': emplIds
            };

            if (isForce) {
              params.isForce = true;
            }

            if (emplIds !== null && emplIds !== void 0 && emplIds.length) {
              _context.next = 17;
              break;
            }

            // без сотрудников ничего не подгружаем
            commit('setIsLoading', false);
            return _context.abrupt("return");

          case 17:
            if (!(tableView === 'factTabel')) {
              _context.next = 23;
              break;
            }

            if (!(!state.updatedData.tabel || isForce)) {
              _context.next = 21;
              break;
            }

            _context.next = 21;
            return dispatch('getTabelData', params);

          case 21:
            _context.next = 57;
            break;

          case 23:
            if (!(!state.updatedData.wStats || isForce)) {
              _context.next = 26;
              break;
            }

            _context.next = 26;
            return dispatch('updateWorkerStats', {});

          case 26:
            if (!tableView.includes('Approved')) {
              _context.next = 30;
              break;
            }

            if (!(!state.updatedData.tasks || isForce)) {
              _context.next = 30;
              break;
            }

            _context.next = 30;
            return dispatch('getTasks', params);

          case 30:
            if (!tableView.toLowerCase().includes('factapproved')) {
              _context.next = 34;
              break;
            }

            if (!(!state.updatedData.attendanceRecords || isForce)) {
              _context.next = 34;
              break;
            }

            _context.next = 34;
            return dispatch('getAttendanceRecords', params);

          case 34:
            if (!(tableView === 'planFactApprovedCompare')) {
              _context.next = 39;
              break;
            }

            if (state.updatedData.planData || state.updatedData.factData) {
              if (!state.updatedData.planData) {
                params['is_fact'] = false;
              }

              if (!state.updatedData.factData) {
                params['is_fact'] = true;
              }
            }

            if (!(!state.updatedData.planData || !state.updatedData.factData || isForce)) {
              _context.next = 39;
              break;
            }

            _context.next = 39;
            return dispatch('getWorkerDays', params);

          case 39:
            if (!tableView.toLowerCase().includes('both')) {
              _context.next = 46;
              break;
            }

            if (!(!state.updatedData.factData || isForce)) {
              _context.next = 44;
              break;
            }

            delete params['is_fact'];
            _context.next = 44;
            return dispatch('getWorkerDays', params);

          case 44:
            _context.next = 57;
            break;

          case 46:
            if (!tableView.includes('fact')) {
              _context.next = 53;
              break;
            }

            if (!(!state.updatedData.factData || isForce)) {
              _context.next = 51;
              break;
            }

            params['is_fact'] = true;
            _context.next = 51;
            return dispatch('getWorkerDays', params);

          case 51:
            _context.next = 57;
            break;

          case 53:
            if (!(!state.updatedData.planData || isForce)) {
              _context.next = 57;
              break;
            }

            params['is_fact'] = false;
            _context.next = 57;
            return dispatch('getWorkerDays', params);

          case 57:
            if (isForce) {
              commit('setTimesheetItems', {
                items: []
              });
            }

            dispatch('applyTableView', {
              tableView: tableView
            });
            commit('setIsLoading', false);

          case 60:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();